import { render, staticRenderFns } from "./FavoriteProductButton.vue?vue&type=template&id=12ddcbef&scoped=true&"
import script from "./FavoriteProductButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteProductButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddcbef",
  null
  
)

export default component.exports